import { Menu, MenuItem } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Toolbar from "@material-ui/core/Toolbar";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { ExpandMore } from "@material-ui/icons";
import MenuIcon from "@material-ui/icons/Menu";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import YoozSvgIcon from "../components/yooz_svg_icon";
import { setTabPosition } from "../uiSlice";
import QuickMenu from "./quickMenu";
import SwipeableNavDrawer from "./swipableNavDrawer";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  menu: {
    marginRight: theme.spacing(0),
    [theme.breakpoints.up("lg")]: {
      marginRight: theme.spacing(2),
    },
  },
  actionButton: {
    borderRadius: 20,
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      whiteSpace: "nowrap",
      fontSize: 10,
    },
  },
  signupIcon: {
    borderRadius: 20,
    marginRight: theme.spacing(1),
    background:"#FFF",
    color:theme.palette.secondary.main,
    [theme.breakpoints.down("xs")]: {
      whiteSpace: "nowrap",
      fontSize: 10,
    },
  },
  loginButton: {
    borderRadius: 20,
    marginRight: theme.spacing(2),
  },
  yoozLogo: {
    width: theme.spacing(8),
    height: "100%",
    // backgroundColor:theme.palette.primary.main
  },
  flex: {
    flexGrow: 1,
  },
  active: {
    color: theme.palette.primary.main,
  },
  tabs: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },
  indicator: {
    backgroundColor: "#FFF !important",
  },
  noIndicator: {
    backgroundColor: "transparent",
  },
}));

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function CustomAppBar(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [scrollPosition, setSrollPosition] = useState(0);
  const [open, setOpen] = React.useState(false);
  const xs = useMediaQuery(theme.breakpoints.down("xs"));
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const { tabPosition } = useSelector((state) => state.ui);
  const match = "";
  const actionRoutes = {
    login: { path: `${match}/login`, label: "Login" },
    signup: { path: `${match}/signup`, label: "Signup" },
    quickpay: { path: `${match}/quickpay`, label: "QUICK PAY" },
    quicktopup: { path: `${match}/quicktopup`, label: "⚡ TOP UP" },
  };

  const routes = [
    { path: `${match}`, label: "HOME", show: true },
    { path: `${match}/donate`, label: "DONATE", show: true },
    { path: `${match}/scan2pay`, label: "SCAN2PAY", show: true },
    { path: `${match}/billpay`, label: "PAY BILLS", show: true },
    { path: `${match}/topup`, label: "TOP UP", show: true },
    { path: `${match}/partners`, label: "GET PAID", show: true },
    { path: `${match}/faq`, label: "FAQs", show: true },
    { path: `${match}/about`, label: "ABOUT US", show: true },
    { path: `${match}/contact`, label: "CONTACT US", show: true },
    { path: `${match}/quickpay`, label: "Quick Pay", show: false },
    { path: `${match}/quicktopup`, label: "⚡ Top Up", show: false },
    { path: `${match}/signup`, label: "Sign Up", show: false },
    { path: `${match}/login`, label: "Login", show: false },
  ];

  const getActiveRoute = (pathname) => {
    const index = routes.findIndex((r) => r.path === pathname);
    if (index >= 0) {
      return index;
    }
    return 0;
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpen(open);
  };

  const handleChange = (event, newValue) => {
    dispatch(setTabPosition(newValue));
    window.scrollTo(0, 0);
  };

  const handleChangeMobile = (newValue) => {
    dispatch(setTabPosition(newValue));
    window.scrollTo(0, 0);
  };
  const handleScroll = () => {
    const position = window.pageYOffset;
    setSrollPosition(position);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuId = "auth-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem
        onClick={handleMenuClose}
        to={actionRoutes.login.path}
        component={Link}
        onClick={() => {
          handleMenuClose();
          window.scrollTo(0, 0);
          handleChange(null, 9);
        }}
      >
        {actionRoutes.login.label}
      </MenuItem>
      <MenuItem
        to={actionRoutes.signup.path}
        component={Link}
        onClick={() => {
          handleMenuClose();
          window.scrollTo(0, 0);
          handleChange(null, 9);
        }}
      >
        {actionRoutes.signup.label}
      </MenuItem>
    </Menu>
  );

  useEffect(() => {
    function setTabByRoute() {
      dispatch(setTabPosition(getActiveRoute(location.pathname)));
    }

    setTabByRoute();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [dispatch]);

  const AntTab = withStyles((theme) => ({
    root: {
      textTransform: "none",
      minWidth: 72,
      color: "#FFF",
      marginRight: theme.spacing(2),
      "& selected": {
        fontWeight: theme.typography.fontWeightBold,
      },
    },
  }))((props) => <Tab {...props} />);

  return (
    <AppBar
      // className={classes.appBar}
      position={xs ? "sticky" : "fixed"}
      style={{
        background:
          scrollPosition > 0 || xs
            ? theme.palette.secondary.main
            : "linear-gradient(180deg, #224E7F 40%, rgba(0,0,0,0) 100%)",
        boxShadow:
          scrollPosition > 0
            ? "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)"
            : "none",
      }}
    >
      <Toolbar className={classes.toolbar}>
        {sm && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer(true)}
            edge="start"
          >
            <MenuIcon color={"inherit"} />
          </IconButton>
        )}
        <IconButton
          edge="start"
          // color="inherit"
          color="primary"
          component={Link}
          to="/"
          onClick={() => handleChange(null, 0)}
        >
          <YoozSvgIcon
            height="100%"
            width={xs ? 70 : sm ? 80 : 110}
            color={"#FFF"}
          />
        </IconButton>
        <div className={classes.flex} />
        <Tabs
          value={tabPosition}
          onChange={handleChange}
          className={classes.tabs}
          indicatorColor="primary"
          classes={{
            indicator: classes.indicator,
          }}
        >
          {routes.map((route, index) => {
            return route.show && index <= 5 ? (
              <AntTab
                key={index}
                label={route.label}
                to={route.path}
                component={Link}
                {...a11yProps(index)}
              />
            ) : (
              <AntTab
                style={{ display: "none" }}
                key={index}
                label={route.label}
                to={route.path}
                component={Link}
                {...a11yProps(index)}
              />
            );
          })}
        </Tabs>
        <div className={classes.menu} />
        <QuickMenu actionRoutes={actionRoutes} handleChange={handleChange} />
        {xs ? (
          <Button
            edge="end"
            aria-label="account of current user"
            aria-controls={menuId}
            aria-haspopup="true"
            onClick={handleProfileMenuOpen}
            color="inherit"
            endIcon={<ExpandMore />}
          >
            Login
          </Button>
        ) : (
          <Fragment>
            <Button
              color="secondary"
              size={sm ? "small" : "medium"}
              variant={"outlined"}
              to={actionRoutes.login.path}
              component={Link}
              className={classes.actionButton}
              onClick={() => {
                window.scrollTo(0, 0);
                handleChange(null, 9);
              }}
              style={{
                color: "#FFF",
                borderColor: "#FFF",
              }}
            >
              {actionRoutes.login.label}
            </Button>
            <Button
              color="inherit"
              size={sm ? "small" : "medium"}
              variant={"contained"}
              to={actionRoutes.signup.path}
              component={Link}
              className={classes.signupIcon}
              onClick={() => {
                window.scrollTo(0, 0);
                handleChange(null, 9);
              }}
              style={{
                borderColor: theme.palette.primary.main,
              }}
            >
              {actionRoutes.signup.label}
            </Button>
          </Fragment>
        )}
      </Toolbar>
      {renderMenu}
      <SwipeableNavDrawer
        open={open}
        toggleDrawer={toggleDrawer}
        value={tabPosition}
        setValue={handleChangeMobile}
        routes={routes}
      />
    </AppBar>
  );
}
